import React, { ReactNode } from 'react';

interface PageContainerProps {
  children: ReactNode;
  withBackground?: boolean;
}

const PageContainer = ({ children, withBackground = false }: PageContainerProps) => {
  return (
    <div className="container mx-auto px-4 py-6 lg:pt-4 lg:pb-8 overflow-x-hidden">
      {withBackground ? (
        <div className="w-full p-2 sm:p-6 bg-[var(--background-color)] dark:bg-[#1D1D1D] border border-gray-200 dark:border-[#292929] rounded-[8px] text-gray-800 dark:text-gray-200">
          {children}
        </div>
      ) : (
        children
      )}
    </div>
  );
};

export default PageContainer; 